class CustomerReviews {
  constructor(section) {
    this.section = section;
    const rawId = section.getAttribute('id') || '';
    this.sectionId = rawId.replace('section-', '');

    this.modal =
      document.querySelector(`#ReviewsVideoModal-${this.sectionId}`) ||
      section.querySelector('.customer-reviews__modal') ||
      (section.nextElementSibling && section.nextElementSibling.classList.contains('customer-reviews__modal')
        ? section.nextElementSibling
        : null) ||
      document.querySelector('.customer-reviews__modal');

    if (this.modal) {
      this.modalContent = this.modal.querySelector('.customer-reviews__modal-content');
      this.videoWrapper = this.modal.querySelector('.customer-reviews__modal-video-wrapper');
      this.closeBtn = this.modal.querySelector('.customer-reviews__modal-close');
      this.overlay = this.modal.querySelector('.customer-reviews__modal-overlay');
    }

    this.init();
  }

  init() {
    if (!this.section || !this.modal) return;

    this.section.querySelectorAll('.customer-reviews__card--video').forEach((card) => {
      card.addEventListener('click', (e) => this.handleCardClick(e, card));
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeModal());
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeModal());
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal && this.modal.classList.contains('is-open')) {
        this.closeModal();
      }
    });
  }

  handleCardClick(e, card) {
    e.preventDefault();
    const rawUrl = (card.dataset.videoUrl || '').trim();
    let videoType = (card.dataset.videoType || '').toLowerCase();
    let videoId = rawUrl;

    if (rawUrl.includes('youtube.com') || rawUrl.includes('youtu.be')) {
      videoType = 'youtube';
      if (rawUrl.includes('v=')) {
        videoId = rawUrl.split('v=')[1].split('&')[0];
      } else if (rawUrl.includes('youtu.be/')) {
        videoId = rawUrl.split('youtu.be/')[1].split('?')[0];
      } else if (rawUrl.includes('shorts/')) {
        videoId = rawUrl.split('shorts/')[1].split('?')[0];
      }
    } else if (rawUrl.includes('vimeo.com')) {
      videoType = 'vimeo';
      const vimeoMatch = rawUrl.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) videoId = vimeoMatch[1];
    }

    let html = '';
    if (videoType === 'youtube') {
      if (this.modalContent) this.modalContent.classList.add('is-landscape');
      html = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoType === 'vimeo') {
      if (this.modalContent) this.modalContent.classList.add('is-landscape');
      html = `<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoType === 'mp4' || rawUrl) {
      if (this.modalContent) this.modalContent.classList.remove('is-landscape');
      html = `<video src="${rawUrl}" autoplay controls playsinline style="width:100%;height:100%;object-fit:contain;"></video>`;
    }

    if (html && this.videoWrapper) {
      this.videoWrapper.innerHTML = html;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      const videoElem = this.videoWrapper.querySelector('video');
      if (videoElem) {
        videoElem.play().catch(() => {});
      }
    }
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    if (this.videoWrapper) {
      this.videoWrapper.innerHTML = '';
    }
    document.body.style.overflow = '';
  }
}

function initCustomerReviews() {
  document.querySelectorAll('.customer-reviews').forEach((section) => {
    if (!section.dataset.customerReviewsInitialized) {
      new CustomerReviews(section);
      section.dataset.customerReviewsInitialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomerReviews);
} else {
  initCustomerReviews();
}

document.addEventListener('shopify:section:load', initCustomerReviews);
